import React from 'react';
import { useDesign } from '../../designs';

interface DateSpinnerProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  min?: string;
}

export default function DateSpinner({ label, value, onChange, min }: DateSpinnerProps) {
  const design = useDesign();
  const d = design.tokens;
  const fs = design.typography.fontSize;

  return (
    <div style={{ flex: 1 }}>
      <label style={{
        display: 'block', fontFamily: "'Raleway', sans-serif",
        fontSize: fs.sectionHeader, fontWeight: 700, letterSpacing: '1.5px',
        textTransform: 'uppercase', color: d.textSecondary, marginBottom: '6px',
      }}>{label}</label>
      <input
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        min={min}
        onFocus={(e) => { e.target.style.borderColor = 'rgba(200,146,58,0.30)'; }}
        onBlur={(e) => { e.target.style.borderColor = 'rgba(200,146,58,0.10)'; }}
        style={{
          width: '100%', padding: '10px 12px', minHeight: '41px',
          lineHeight: 1.2,
          fontFamily: "'Raleway', sans-serif", fontSize: fs.bodyInput, fontWeight: 400,
          color: d.textPrimary, backgroundColor: d.bgSurface,
          border: '1px solid rgba(200,146,58,0.10)',
          borderRadius: '2px', outline: 'none',
          boxSizing: 'border-box', WebkitAppearance: 'none', MozAppearance: 'none',
        }}
      />
    </div>
  );
}
